module.exports = __webpack_public_path__ + "dashboard/Email.jpg";